import { ZomentumEntities } from "@/Contracts";
import { postRequest } from "@/Utils/Service/BackendService";
import axios, { AxiosResponse } from "axios";

export interface FormulaTestResponse {
	result: number;
}

const testFormulaUrl = "/v2/custom/fields/formula/test";
const generateFormulaUrl = "/v2/custom/fields/formula/generate-ai";

export const testFormula = async (
	formula: string,
	fieldValueMap: { [key: string]: string },
	decimalPlaces?: number
): Promise<FormulaTestResponse> => {
	try {
		const response: AxiosResponse<FormulaTestResponse> = await axios(
			postRequest(
				testFormulaUrl,
				{
					formula,
					field_value_map: fieldValueMap,
					...(decimalPlaces !== undefined && {
						decimal_places: decimalPlaces
					})
				},
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const generateFormula = async (
	entityType: ZomentumEntities,
	query: string
) => {
	try {
		const response: AxiosResponse<any> = await axios(
			postRequest(
				`${generateFormulaUrl}?entity_type=${entityType}`,
				{
					entityType,
					query
				},
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
